"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _Connector = require("./Connector");
var _constants = require("../../../utils/constants");
var _useGetComponentsByParams = require("../../../hooks/store/useGetComponentsByParams");
var _selectors = require("../../../redux/selectors");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
const ConnectBetweenHtgCcAndHtgHx = props => {
  const p = Object.assign({}, (_objectDestructuringEmpty(props), props));
  const type = _constants.TypesConnect.ConnectFromHtgHxToHtgCc;
  const modelShow = (0, _reactRedux.useSelector)(_selectors.selectStructureShowModel)[type];
  const modelPosition = (0, _reactRedux.useSelector)(_selectors.selectStructurePositions)[type];
  const htgHxGroups = (0, _useGetComponentsByParams.useGetComponentsByDepAndByType)({
    type: _constants.TypesByDep.HtgHx
  });
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement("group", _extends({
    dispose: null,
    position: modelPosition
  }, p), modelShow ? htgHxGroups.length ? htgHxGroups.map((item, index) => {
    const connectWithPrevious = item.connectWithNext && index > 0;
    const isSecond = index === 1;
    const showConnect = !connectWithPrevious && htgHxGroups.length - 1 === index && index !== 0 || !item.connectWithNext && htgHxGroups.length <= 1;
    return !showConnect ? /*#__PURE__*/_react.default.createElement(_Connector.Connector, {
      key: item.id,
      position: [-index * _constants.spaseBetweenModelsByCol, 0, 0],
      pipes: [{
        highlightsType: _constants.pipesTypes.heatingReturn,
        display: true
      }, {
        highlightsType: _constants.pipesTypes.heatingFlow,
        display: true
      }],
      connectTo: !item.connectWithNext && index !== 0 ? _constants.ConnectTo.skipHorizontal : _constants.ConnectTo.right,
      connectWithPrevious: connectWithPrevious,
      index: index,
      isSecondConnect: isSecond
    }) : null;
  }) : /*#__PURE__*/_react.default.createElement(_Connector.Connector, {
    position: [0, 0, 0],
    pipes: [{
      highlightsType: _constants.pipesTypes.heatingReturn,
      display: true
    }, {
      highlightsType: _constants.pipesTypes.heatingFlow,
      display: true
    }],
    connectTo: _constants.ConnectTo.null,
    index: 0
  }) : null), [modelPosition, p, htgHxGroups, modelShow]);
};
var _default = exports.default = ConnectBetweenHtgCcAndHtgHx;